import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../data.service';
import { urls } from '../urls';

@Component({
  selector: 'app-supplier-detail',
  templateUrl: './supplier-detail.component.html',
  styleUrls: ['./supplier-detail.component.scss']
})
export class SupplierDetailComponent implements OnInit {
  sortAscending = true;
  dataSource: Array<any> = [];
  displayColumns: Array<string> = ['TimeAndDate', 'CPONo', 'ProductName', 'ContactPerson', 'TP', 'SP', 'PaymentType', 'MRN', 'LeadTime', 'DeliveryType'];
  supplierId: any;
  productId: any;
  supplierTransactionDetails: any;
  categoryId: any;
  sortedCategoryHierarchy: { key: string; value: any; }[];
  msnDetails: any;
  pageNo: number = 0;
  pageSize: number = 10;
  orderBy: string = 'desc';
  countToStop: boolean;
  isFullListDisplayed: boolean = false;
  showSupplierName: string;
  searchCategoryID: any;
  brandIDs: any;
  searchOpenString: any;
  sor: string="";
  constructor(private paramRoute: ActivatedRoute, private service: DataService, private router: Router,private dataService:DataService) { }

  ngOnInit(): void {
    
    this.paramRoute.queryParams.subscribe(params => {
      this.productId = params['productId'];
      this.supplierId = params['supplierId'];
      this.searchCategoryID = params['category'];
      this.searchOpenString = params['searchStr'] == undefined ? '' : params['searchStr'];
      this.brandIDs = params['brandIds'];
      this.sor=params['sor']
    });

    // this.paramRoute.queryParams.subscribe(params => {
    //   this.productId = params['productId'];
    //   this.supplierId = params['supplierId'];
    //   this.categoryId = params['category'];
    // });
   // this.categoryId=localStorage.getItem("supplierCategory")
    this.breadCrumDataBy(localStorage.getItem("supplierCategory"))
    this.getMsnDetails();
    this.getSupplierTransactionDetails();
  }
  getSupplierTransactionDetails() {
    this.service.onSpinner()
    let url = urls.supplierTransaction + "?msn=" + this.productId + "&supplierId=" + this.supplierId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;
    this.service.callRestful('GET', url, null, null, null, null).subscribe(this.processSupplierResult.bind(this));
    this.dataService.eventTracker("CIS-PORTAL", "Supplier-Details", "", "/supplier-details");
  }

  processSupplierResult(data) {
    
    this.service.offSpinner()
    if (data.status) {
      this.supplierTransactionDetails = data.data;
      this.dataSource = data.data;
      this.showSupplierName = this.dataSource[0].supplierName;
      if (this.dataSource.length < this.pageSize)
        this.countToStop = false
      else
        this.countToStop = true
    } else {
      this.service.showMessage('error', data.message);
    }
  }

  toggleSort() {
    this.sortAscending = !this.sortAscending;

    this.sortAscending = !this.sortAscending;

    this.service.onSpinner()

    if (this.orderBy == 'desc') {
      this.orderBy = 'asc';
    } else {
      this.orderBy = 'desc';
    }
    let url = urls.supplierTransaction + "?msn=" + this.productId + "&supplierId=" + this.supplierId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;
    this.service.callRestful('GET', url, null, null, null, null).subscribe(this.processSupplierResult.bind(this));


  }

  onSupplierPage() {

    const queryParams: any = {};
    if (this.searchCategoryID) {
      queryParams.category = this.searchCategoryID;
    }
    if (this.brandIDs && this.brandIDs.length > 0) {
      queryParams.brandIds = this.brandIDs;
    }

    if (this.searchOpenString) {
      queryParams.searchStr = this.searchOpenString;
    }
    if (this.productId) {
      queryParams.productId = this.productId;
    }
    if (this.sor) {
      queryParams.sor = this.sor;
    }
   

    this.router.navigate(['/supplier-discovery'], { queryParams });
    
   // this.router.navigateByUrl('/supplier-discovery?category=' + this.categoryId + '&productId=' + this.productId);
  }


  breadCrumDataBy(categoryId): Promise<any> {
    if (categoryId) {
      return new Promise<any>((resolve, reject) => {
        this.service.getBreadCrumData(categoryId).subscribe(
          (data) => {
            const categoryIdHirarchy = data['categoryHierarchy'];
            this.sortedCategoryHierarchy = Object.keys(categoryIdHirarchy)
              .filter((key) => key.startsWith('category_name_level') && categoryIdHirarchy[key] !== null)
              .sort()
              .map((key) => ({ key: key, value: categoryIdHirarchy[key] }));

            // Get the value of 'category_name' and append it to the sortedCategoryHierarchy array
            const category_name = categoryIdHirarchy['category_name'];
            if (category_name) {
              this.sortedCategoryHierarchy.push({ key: 'category_name', value: category_name });
            }
            localStorage.removeItem("supplierCategory")
            resolve(this.sortedCategoryHierarchy);
          },
          (error) => {
            // Handle error if necessary
            localStorage.removeItem("supplierCategory")
            console.error(error);
            reject(error);
          }
        );
      });
    }
  }


  getMsnDetails(): any {
    this.service.onSpinner()
    let url = urls.msnDetails + this.productId;

    this.service.callRestful('GET', url, null, null, null, null).subscribe(this.processResult.bind(this));
    
  }
  processResult(data) {
    this.service.offSpinner()
    if (data.status) {
      this.msnDetails = data;
    } else {
      this.service.showMessage('error', data.message);
    }

  }



  onScroll() {
    try {


      if (this.dataSource.length > 1 && this.countToStop) {
        this.pageSize += 1;
        this.service.showMessage('success', "Data Loading...")
        let url = urls.supplierTransaction + "?msn=" + this.productId + "&supplierId=" + this.supplierId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;
        this.service.callRestful('GET', url, null, null, null, null, false).subscribe(this.processSupplierResult.bind(this));
      } else {
        this.isFullListDisplayed = true;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //this.loadingMoreData = false;
      // this.dataLoaded = true;
    }
  }


  // Event handler for open filter change
  onCategoryFilterChange(categoryName: string) {
  }


  onBrandFilterChange(brandFilterValue: any[]) {
  }


  // Event handler for open filter change
  onOpenFilterChange(openFilterValue: string) {
  }
  onSearchFilterChange(searchFilterChange: string) {
  }


}
